import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MatTableDataSource } from '@angular/material';
import { Item } from '../../../../interfaces/item';
import { PermisoService } from '../../../../providers/permiso.service';

@Component({
  selector: 'app-listar-items',
  templateUrl: './listar-items.component.html',
  styleUrls: ['./listar-items.component.scss']
})
export class ListarItemsComponent implements OnInit {
  LIMITE_DE_ITEMS_POR_COTIZACION: number = null; // limite de items que se pueden crear
  tablaItemsColumnas = ['producto', 'accesorios', 'cantidad', 'total'];
  itemsDataSource = new MatTableDataSource();
  @Input() items: Item[];
  @Input() acciones: boolean = false; // true para mostrar las acciones de ABM
  @Input() cargando: boolean = false; // true para mostrar el progres var.
  @Output() onChange = new EventEmitter();

  constructor(
    private permisoService: PermisoService
  ) { }

  ngOnInit() {
    if (!this.items) {
      throw "La variable Input 'items' es requerida";
    } else {
      this.itemsDataSource.data = this.items;
    }

    if (this.acciones) { // si solicitan mostrar acciones
      this.permisoService.tienePermiso('ITEM-ACCIONES').then(tienePermiso => { // si tiene permiso
        if (tienePermiso) {
          this.tablaItemsColumnas.push('acciones');
        }
      });
    }
  }

  itemCreado(evento: any) { // agregar dato creado al listado
    if (evento && evento.item) {
      this.items.push(<Item>evento.item);
      this.itemsDataSource.data = this.items;
      this.onChange.emit();
    }
  }

  itemEliminado(index: any) { // quitar del listado según el index
    this.items.splice(index, 1);
    this.itemsDataSource.data = this.items;
    this.onChange.emit();
  }

  itemEditado(index: any, evento: any) { // editar el dato según el index y los datos
    this.items[index] = <Item>evento.item;
    this.itemsDataSource.data = this.items;
    this.onChange.emit();
  }

  setItems(items: Item[]): void { // actualizar listado
    this.items = items;
    this.itemsDataSource.data = this.items;
    this.onChange.emit();
  }

  setCargando(cargando: boolean = true): void { // cambiar el estado de la barra de cargando
    this.cargando = cargando;
  }
}
